import { get } from 'api/axios-client';
import { API_ENDPOINTS } from '../constants';
import { AuditLogEntry, AuditLogQuery, AuditLogResponse } from '../types';
import { logger } from '../utils/logger';

export interface AuditModuleOption {
  value: string;
  label: string;
}
const controllerUrl = 'api/Audit/';
class AuditService {
  async getAuditLogs(query: AuditLogQuery): Promise<AuditLogResponse> {
    try {
      logger.info('Fetching audit logs', { query });

      const params: Record<string, string | number | boolean | undefined> = {
        search: query.search,
        startDate: query.startDate,
        endDate: query.endDate,
        module: query.module,
        userId: query.userId,
        entityType: query.entityType,
        recordNo: query.recordNo,
        page: query.page,
        limit: query.limit,
        ...(query.settingsEntitiesOnly ? { settingsEntitiesOnly: true } : {}),
      };
      const url = `${controllerUrl}GetAuditLogs`;
      const response = await get<AuditLogResponse>(url, {
        params,
      });

      const payload = response.data as AuditLogResponse & {
        message?: string;
        Message?: string;
      };
      const apiError = payload?.message ?? payload?.Message;
      if (apiError) {
        throw new Error(apiError);
      }

      const rows = Array.isArray(payload?.data) ? payload.data : [];
      const pagination = payload?.pagination ?? {
        page: query.page ?? 1,
        limit: query.limit ?? 25,
        total: 0,
        totalPages: 0,
      };

      logger.info('Audit logs fetched', {
        count: rows.length,
        total: pagination.total,
      });
      return { data: rows, pagination };
    } catch (error) {
      logger.error('Failed to fetch audit logs', { query }, error as Error);
      throw error;
    }
  }

  async getModules(): Promise<AuditModuleOption[]> {
    // Hardcoded modules per requirement
    return [
      { value: 'customer', label: 'Customer' },
      { value: 'part', label: 'Parts' },
      { value: 'unit', label: 'Units' },
    ];
  }

  async getSettingsAuditEntityNames(): Promise<string[]> {
    const url = `${controllerUrl}GetSettingsAuditEntityNames`;
    const response = await get<string[]>(url);
    return response.data;
  }

  async exportAuditLogs(query: AuditLogQuery): Promise<Blob> {
    try {
      logger.info('Exporting audit logs', { query });
      const params: Record<string, string | number | undefined> = {
        search: query.search,
        startDate: query.startDate,
        endDate: query.endDate,
        module: query.module,
      };

      const response = await get<Blob>(API_ENDPOINTS.AUDIT.EXPORT, {
        params,
        responseType: 'blob' as any,
      } as any);

      logger.info('Audit logs export ready');
      return response.data as unknown as Blob;
    } catch (error) {
      logger.error('Failed to export audit logs', { query }, error as Error);
      throw error;
    }
  }
}

export const auditService = new AuditService();
export default auditService;
